import { useRouter } from "next/router";
import { useEffect } from "react";

function FlixMedia({ product }) {
  const product_mpn = product?.model
    ? product?.model?.length > 0
      ? product?.model[0]
      : ""
    : "";
  const product_ean = product?.model
    ? product?.model?.length > 0
      ? product?.model[0]
      : ""
    : "";
  const product_brand = product?.brand
    ? product?.brand?.length > 0
      ? product?.brand[0]
      : ""
    : "";
  const { locale } = useRouter();
  useEffect(() => {
    if (
      typeof flixJsCallbacks === "object" &&
      typeof window?.flixJsCallbacks?.reset != "undefined"
    )
      window.flixJsCallbacks.reset();
    const distributor = "14292";
    const language = locale === "ar" ? "ar" : "d2";
    const headID = document.getElementsByTagName("head")[0];
    const flixScript = document.createElement("script");
    flixScript.type = "text/javascript";
    flixScript.async = true;
    flixScript.id = "1452";
    flixScript.setAttribute("data-flix-distributor", distributor);
    flixScript.setAttribute("data-flix-language", language);
    flixScript.setAttribute("data-flix-fallback-language", "ar");
    flixScript.setAttribute("data-flix-brand", product_brand);
    flixScript.setAttribute("data-flix-ean", product_ean);
    flixScript.setAttribute("data-flix-mpn", product_mpn);
    flixScript.setAttribute("data-flix-inpage", "flix-inpage");
    flixScript.setAttribute("data-flix-button", "flix-minisite");
    flixScript.setAttribute("data-flix-price", "");
    headID.appendChild(flixScript);
    flixScript.src = "//media.flixfacts.com/js/loader.js";
    return () => {
      document.getElementById("1452").remove();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [locale]);
  return <></>;
}

export default FlixMedia;
